import { POSTAnueHaoCategoryPosts, PostAnueHaoHotPosts } from '@fe-news/api/hao';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const LIMIT = 10;

type HaoPostProps = {
  Ordinal: number;
  文章Id: number;
  文章型態: string;
  標題: string;
  摘要: string;
  貼文插件型態: string;
  長文發布時間: string;
  _號: string;
  CreatedAt: string;
};

/**
 * 鉅亨號資料取得方式
 *
 * 1. 判斷 “List_文章__置頂” 置頂文是否有 Ordinal > 1000 的文章，如果有依照 Ordinal 大到小排序
 * 2. 取 “Page_文章” 前 10 則
 */
function parseHotPost(list: HaoPostProps[], page: HaoPostProps[]) {
  // List 置頂文章依照 Ordinal 大小排序
  const sortList = list
    .filter((p: HaoPostProps) => p.Ordinal > 1000)
    .sort((a: HaoPostProps, b: HaoPostProps) => {
      return a.Ordinal > b.Ordinal ? -1 : 1;
    });
  // 文章數量為，置頂文章 2 篇 + 文章 10 篇
  return [...sortList.splice(0, 2), ...page.splice(0, 10)];
}

/**
 * 鉅亨號熱門貼文會有作者沒有勾勾, 要過濾掉
 */
const filterUncertification = (posts = []) => {
  return posts.filter(post => post?.['_號']?.['號認證Ids']);
};

const fetchHao = async (category = '') =>
  category === '' ? await fetchHotArticlesOfHao() : await fetchArticlesOfHaoCategory(category);

/**
 * 取得鉅亨號熱門貼文
 * 用在首頁
 */
const fetchHotArticlesOfHao = async () => {
  try {
    const response = await PostAnueHaoHotPosts();
    const data = response.payload?.Root || null;

    if (data) {
      const listPosts = data['List_文章__置頂'] || [];
      const pagePosts = data['Page_文章']['List_文章'] || [];
      const posts = parseHotPost(listPosts, filterUncertification(pagePosts));

      return posts;
    }
  } catch (error) {
    console.error('[鉅亨號貼文API錯誤]:', error);

    return [];
  }
};

/**
 * 取得鉅亨號指定分類貼文
 * 用在內頁，對應不同分類
 */
const fetchArticlesOfHaoCategory = async (category: string) => {
  try {
    const response = await POSTAnueHaoCategoryPosts(category);
    const data = response.payload || null;

    if (data) {
      return data['List_文章'].slice(0, LIMIT);
    }
  } catch (error) {
    throw new Error(`[鉅亨號指定分類貼文API錯誤]: ${error}`);
  }
};

const haoApi = (category = '') => ({
  queryKey: ['haoApi'] as [string],
  queryFn: () => fetchHao(category)
});

const hao = createQueryKeys('hao', {
  haoApi
});

export default hao;
